/**
 * Contact API Endpoints
 * Centralized endpoint definitions
 * Base URL: from .env
 * Prefix: /frontend
 */

const CONTACT_ENDPOINTS = {
  // Contact/Support
  CREATE_SUPPORT: '/frontend/create-support',
};

export default CONTACT_ENDPOINTS;
